<template>
  <component-wrapper class="brochures-fi">
    <grid-container-fi>
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12">
        <richtext-fi
          v-if="fields?.headline?.value || isEditMode"
          class="brochures-fi__headline"
          :html-content="fields.headline"
        />
      </div>
    </grid-container-fi>
    <grid-container-fi :container="false">
      <div class="fi-col-span-full">
        <tab-navigation-fi
          :tab-navigation="tabNavigation"
          :is-slider="true"
          :no-spacing-below="true"
          @change="(value) => tabChanged(value)"
        />
      </div>
    </grid-container-fi>
    <grid-container-fi :container="false">
      <div class="brochures-fi__container fi-col-span-full">
        <grid-container-fi>
          <div
            class="brochures-fi__content-wrapper fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12"
          >
            <!-- eslint-disable vue/no-v-html -->
            <h3
              v-if="isEditMode"
              class="brochures-fi__tiles-intro-text"
              v-html="fields.tilesIntroText.editable"
            />
            <h3
              v-else
              class="brochures-fi__tiles-intro-text"
              v-html="fields.tilesIntroText ? fields.tilesIntroText.value : ''"
            />

            <loading-indicator
              v-if="isLoading"
              variant="spinnerLocal"
              class="spinner-local--rebrush"
              dark
            />

            <!-- eslint-enable vue/no-v-html -->
            <transition
              enter-active-class="animated fadeIn fastest"
              leave-active-class="animated fadeOut fastest"
              mode="out-in"
            >
              <div
                :key="currentTag.id"
                class="brochures-fi__tiles-wrapper"
              >
                <div class="brochures-fi__brochure-tiles">
                  <brochure-tile-fi
                    v-for="(brochure, index) in brochureList"
                    :key="brochure.Document.Download + index"
                    :title="brochure.Document.BrochureTitle"
                    :preview-text="brochure.Document.PreviewText"
                    :download-url="brochure.Document.Download"
                    :thumbnail-url="brochure.Document.Thumbnail"
                  />
                </div>
              </div>
            </transition>
          </div>
        </grid-container-fi>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import { LoadingIndicator, RichtextFi } from 'atoms';
import axios from 'axios';
import BrochureTileFi from 'components/brochure-tile-fi/BrochureTileFi';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import TabNavigationFi from 'components/tab-navigation-fi/TabNavigationFi';
import { useSSRContext } from 'vue';

export default {
  name: 'BrochuresFi',
  components: {
    LoadingIndicator,
    ComponentWrapper,
    GridContainerFi,
    TabNavigationFi,
    BrochureTileFi,
    RichtextFi,
  },
  inject: ['fields', 'prefetch'],
  data() {
    return {
      brochureList: [],
      isLoading: true,
      currentTag: {
        id: 0,
      },
    };
  },
  computed: {
    tags() {
      if (this.fields?.tags?.length) {
        return this.fields.tags.filter(
          (tag) => tag.fields?.tagName?.value && tag.fields.tagName.value !== '',
        );
      }

      return [];
    },
    tabNavigation() {
      if (this.tags.length) {
        const navigation = this.tags.map((tag, index) => ({
          id: index,
          text: tag.fields?.tagName?.value,
          tagId: tag.id,
        }));

        return navigation;
      }

      return null;
    },
    fetchParams() {
      const lang = this.$fischer.siteLanguage() || null;
      if (!lang || !this.tabNavigation) {
        return null;
      }
      const { tagId } = this.tabNavigation[0];
      const currentTag = this.currentTag.tagId || tagId;

      return {
        lang,
        tags: currentTag,
      };
    },
    cacheKey() {
      if (!this.fetchParams) {
        return null;
      }
      return `${this.fetchParams.lang} ${this.fetchParams.tags}`;
    },
  },
  async serverPrefetch() {
    await this.fetchData();
    this.ctx.prefetch = this.cache;
  },
  created() {
    if (IS_SSR) {
      this.cache = {};
      this.ctx = useSSRContext() || {};
    } else {
      this.cache = this.prefetch || {};
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    tabChanged(value) {
      this.isLoading = true;
      this.currentTag = value;
      this.fetchData();
    },
    async fetchData() {
      try {
        const fromCache = this.cache[this.cacheKey];
        if (fromCache) {
          this.brochureList = fromCache;
          return;
        }
        let url = '/api/brochures/get';
        if (IS_SHOWROOM) {
          url = `/__mocks__/sitecoreApi${url}/mockedBrochuresData.json`;
        }
        if (IS_SSR) {
          url = `${this.$fischer.hostUrlBase()}${url}`;
        }

        if (!this.fetchParams) {
          console.error('Missing parameters', this.fetchParams);
          return;
        }
        const result = await axios.get(url, {
          params: this.fetchParams,
        });
        if (result.data?.Data?.TeaserList) {
          this.brochureList = result.data.Data.TeaserList;
          this.cache[this.cacheKey] = this.brochureList;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import './brochures-fi';
</style>
